export const LAYOUT_VIEWPORT_HEIGHT = 'calc(100vh - 3.5rem)';
